<template>
  <v-app>
    <alert-component/>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

import AlertComponent from "@/components/AlertComponent";
export default {
  name: 'App',
  components: {AlertComponent},
  data() {
    return {

    }
  },
  mounted() {
    if (this.$route.path.includes('subscribed')) {
      this.$root.$emit('alert', {type: 'success', message: this.$route.params.message, show: true})
    }
  }
};
</script>
